import type { VerificationResult } from "../types/verification";

const API_URL = import.meta.env.VITE_VERIFY_API_URL!;

const UPLOAD_URL =
  import.meta.env.VITE_UPLOAD_URL || "https://api.stivistodrive.com/upload";

export async function uploadBlobToDrive(blob: Blob): Promise<string | null> {
  const formData = new FormData();
  formData.append("body", blob);
  try {
    const resp = await fetch(UPLOAD_URL, { method: "POST", body: formData });
    if (!resp.ok) return null;
    const json = (await resp.json()) as { url?: string };
    return json?.url ?? null;
  } catch {
    return null;
  }
}

export interface APIResponse {
  ok: boolean;
  reason?: string;
}

export async function sendVerificationResult(
  result: VerificationResult,
  screenshotUrls: string[] = [],
): Promise<APIResponse> {
  const initData =
    (typeof window !== "undefined" && window.Telegram?.WebApp?.initData) || "";

  const res = await fetch(API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      initData,
      screenshotUrls,
      ...result,
    }),
  });

  try {
    return (await res.json()) as APIResponse;
  } catch {
    return { ok: false, reason: "try_later" };
  }
}
